// MITI CRM tracking (Product Reach): remembers which channel brought the visitor
// (Instagram, WhatsApp, Google, an ad…) so their signup, trial and payments are
// credited to it in the CRM. Off unless REACT_APP_CRM_TRACKING_URL (the CRM
// frontend's address, e.g. https://appcrm.miti.us) is set at build time.
// REACT_APP_CRM_TRACKING_DOMAINS: BulkSigner's other sites (marketing site, blog),
// comma-separated, so a visitor moving between them keeps one journey.
const base = (process.env.REACT_APP_CRM_TRACKING_URL || '').trim().replace(/\/+$/, '');

if (base && typeof document !== 'undefined' && !window.MitiTrack && !document.querySelector('script[data-mt-loader]')) {
  const script = document.createElement('script');
  script.src = `${base}/t.js`;
  script.async = true;
  script.setAttribute('data-mt-loader', '1');
  const domains = (process.env.REACT_APP_CRM_TRACKING_DOMAINS || '').trim();
  if (domains) script.setAttribute('data-domains', domains);
  document.head.appendChild(script);
}

/** Where this visitor came from, to send with the registration (null when tracking is off). */
export const crmAttribution = () =>
  (typeof window !== 'undefined' && window.MitiTrack ? window.MitiTrack.get() : null);
